export const breakpoints = {
  xs: "@media (min-width: 480px)",
  sm: "@media (min-width: 768px)",
  md: "@media (min-width: 992px)",
  lg: "@media (min-width: 1150px)",
  xl: "@media (min-width: 1441px)",
};

export const fadeInAndOutVariants = ({
  animateDelay = 0,
  exitDelay = 0,
} = {}) => ({
  initial: { opacity: 0 },
  animate: {
    opacity: 1,
    transition: {
      delay: animateDelay,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      delay: exitDelay,
    },
  },
});

export const fadeInAndOutAndAnimateHeightVariants = () => ({
  initial: {
    opacity: 0,
    height: 0,
  },
  animate: {
    opacity: 1,
    height: "auto",
    transition: {
      ease: "easeInOut",
      duration: 0.2,
      opacity: {
        delay: 0.1,
      },
    },
  },
  exit: {
    opacity: 0,
    height: 0,
    transition: {
      ease: "easeInOut",
      duration: 0.2,
      height: {
        delay: 0.1,
      },
    },
  },
});
